import routes from '@/web-api/routes';
import axios from 'axios';

function handleCloseTransitionMessage() {
  const closeButton = document.getElementById('transition-message-close-action');

  if (!closeButton) {
    return;
  }

  closeButton.addEventListener('click', () => {
    axios.post(routes.webapi.dismissTransitionMessage).then(() => {
      document.getElementById('transition-message').classList.add('hidden');
    });
  });
}

handleCloseTransitionMessage();
